import {Injectable} from '@angular/core';
import {Device} from '@awesome-cordova-plugins/device/ngx';
import {Observable, of} from 'rxjs';
import {shareReplay, switchMap} from 'rxjs/operators';
import {IziviaStorageService} from './storage/iziviaStorage.service';
import {IziviaPlatformService} from './iziviaPlatform.service';
import {v4 as uuidv4} from 'uuid';
import {DEVICE_ID} from './storage/iziviaStorage.keys';

@Injectable({
    providedIn: 'root'
})
export class IziviaMobileDeviceService {
    public readonly deviceId$: Observable<string>;

    constructor(private readonly device: Device,
        private readonly platformService: IziviaPlatformService,
        private readonly storageService: IziviaStorageService) {
        this.deviceId$ = this.platformService.ready()
            .pipe(
                switchMap(() => this.storageService.get<string>(DEVICE_ID)),
                switchMap(deviceId => {
                    if (!deviceId) {
                        deviceId = this.fetchDeviceId();
                        return this.storageService.set<string>(DEVICE_ID, deviceId);
                    } else {
                        return of(deviceId);
                    }
                }),
                shareReplay(1)
            );
    }

    /**
     * Cannot rely on platform.is('desktop') or platform.is('mobile') for this because modern browsers are able
     * to impersonate user agent of real mobile devices when toggling mobile developer tools
     * See also: https://github.com/ionic-team/ionic/blob/master/core/src/utils/platform.ts
     */
    public isMobileDevice(): boolean {
        return this.platformService.get().is('cordova')
            && !!this.device.uuid;
    }

    private fetchDeviceId(): string {
        if (this.isMobileDevice()) {
            return this.device.uuid;
        } else {
            return uuidv4();
        }
    }
}
